import axios from 'axios'
import store from '../store'
import context from '../main'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 15000 // 请求超时的时间
})

// axios 请求拦截器
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  console.log(store.state.token)
  if (store.state.token) {
    config.data = { ...config.data, token: store.state.token, userId: store.state.userId }
  }
  return config
}, error => {
  Promise.reject(error)
})

// axios 响应拦截器
service.interceptors.response.use(response => {
  const res = response.data
  if (res.errorCode !== 200) {
    console.log(res)
    if (res.errorCode === -10001) {
      if (context) {
        context.$createToast({
          txt: '登录失效， 请重新登录',
          type: 'txt'
        }).show();
        setTimeout(() => {
          store.dispatch('LoginOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          });
        } , 1000)
      } else {
        store.dispatch('LoginOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        });
      }
      
      
    } else {
      return response.data
    }
  } else {
    return response.data
  }
}, error => {
  console.log('err' + error) // fordebug
  return Promise.reject(error)
})

export default service
